__turbopack_context__.v({
  "button": "button-module__PBMhJa__button",
  "checked": "button-module__PBMhJa__checked",
  "circular": "button-module__PBMhJa__circular",
  "destructive": "button-module__PBMhJa__destructive",
  "disabled": "button-module__PBMhJa__disabled",
  "icon": "button-module__PBMhJa__icon",
  "iconFilled": "button-module__PBMhJa__iconFilled",
  "iconOnly": "button-module__PBMhJa__iconOnly",
  "iconRegular": "button-module__PBMhJa__iconRegular",
  "label": "button-module__PBMhJa__label",
  "large": "button-module__PBMhJa__large",
  "link": "button-module__PBMhJa__link",
  "loadedContent": "button-module__PBMhJa__loadedContent",
  "loader": "button-module__PBMhJa__loader",
  "loading": "button-module__PBMhJa__loading",
  "medium": "button-module__PBMhJa__medium",
  "outline": "button-module__PBMhJa__outline",
  "primary": "button-module__PBMhJa__primary",
  "secondary": "button-module__PBMhJa__secondary",
  "small": "button-module__PBMhJa__small",
  "square": "button-module__PBMhJa__square",
  "subtle": "button-module__PBMhJa__subtle",
  "success": "button-module__PBMhJa__success",
  "transparent": "button-module__PBMhJa__transparent",
  "wrap": "button-module__PBMhJa__wrap",
});
